import type { LangCode } from '@/lib/i18n/lang';
import { getCapitaalePartnerUrl } from '@/lib/capitaalePartnerUrl';
import type { MarketingPartnerDef, PartnerLink } from '@/lib/marketing/partners';

export function resolvePartnerLinks(partner: MarketingPartnerDef, lang: LangCode): PartnerLink[] {
  if (partner.localeAwareHref && partner.id === 'capitaale') {
    return partner.links.map((link) => ({
      ...link,
      href: getCapitaalePartnerUrl(lang),
    }));
  }
  return partner.links;
}

export function partnerLinkRel(partner: MarketingPartnerDef): string {
  return partner.localeAwareHref ? 'noopener noreferrer sponsored' : 'noopener noreferrer';
}
